import React from "react";

import RegistrationForm from "./RegistrationForm";
import RegisterFormCarousel from "./RegisterFormCarousel";

import { DEFAULT_URL_ARGUMENTS } from "@/constants";

import { RegisterFormSectionDataI } from "../shyftPassMaps";

import styles from "./RegisterFormSection.module.scss";
import { generateUrlArguments } from "@/utils";

interface RegisterFormSection extends RegisterFormSectionDataI {}

const RegisterFormSection: React.FC<RegisterFormSection> = ({ ...rest }) => {
  let urlParams = "";
  if (typeof window !== "undefined") {
    urlParams = window.location.search;
  }

  const urlsArguments = generateUrlArguments(
    urlParams || DEFAULT_URL_ARGUMENTS
  );
  const registerForm = (
    <RegistrationForm urlsArguments={urlsArguments} {...rest} />
  );

  const registerFormCarousel = <RegisterFormCarousel />;

  return (
    <div
      id="shyft-pass-register-section"
      className={["container", styles.registerFormSection].join(" ")}
    >
      {registerForm}
      {registerFormCarousel}
    </div>
  );
};

export default RegisterFormSection;
